export function buildSearchUrl(
  apiUrl: string,
  scope: string,
  q: string,
  selected: Record<string, string[]>,
  tagFilters: string[] = [],
  sort = "",
  offset = 0,
  hits = 10,
): string {
  const params = new URLSearchParams({
    scope,
    q: q || "*",
    offset: String(offset),
    hits: String(hits),
  });
  Object.entries(selected).forEach(([group, values]) => {
    values.forEach((value) => params.append("filters", `${group}::${value}`));
  });
  tagFilters.forEach((v) => params.append("checkboxes", v));
  if (sort) params.set("sort", sort);
  return `${apiUrl}?${params.toString()}`;
}

export function buildBrowserSearch(
  q: string,
  selected: Record<string, string[]>,
  tagFilters: string[] = [],
  sort = "",
  offset = 0,
  hits = 10,
): string {
  const params = new URLSearchParams();
  if (q.trim()) params.set("q", q.trim());
  Object.entries(selected).forEach(([group, values]) => {
    values.forEach((value) => params.append("filters", `${group}::${value}`));
  });
  tagFilters.forEach((value) => params.append("checkboxes", value));
  if (sort) params.set("projectSearchSort", sort);
  if (offset > 0 || hits > 0) {
    params.set("offset", String(offset));
    params.set("hits", String(hits));
  }
  const queryString = params.toString();
  return queryString ? `?${queryString}` : "";
}

export function readBrowserState(search: string): {
  query: string;
  selected: Record<string, string[]>;
  tagFilters: string[];
  sort: string;
  offset: number;
  hits: number;
} {
  const params = new URLSearchParams(search);
  const selected: Record<string, string[]> = {};
  params.getAll("filters").forEach((filterValue) => {
    const [group, value] = filterValue.split("::");
    if (!group || !value) return;
    selected[group] = [...(selected[group] ?? []), value];
  });
  return {
    query: params.get("q") ?? "",
    selected,
    tagFilters: params.getAll("checkboxes"),
    sort: params.get("projectSearchSort") ?? params.get("sort") ?? "",
    offset: Number(params.get("offset") ?? "0"),
    hits: Number(params.get("hits") ?? "10"),
  };
}

export function normalizeSelectedFilters(
  selectedFilters: Record<string, string[]>,
): Record<string, string[]> {
  return Object.keys(selectedFilters)
    .sort()
    .reduce<Record<string, string[]>>((accumulator, key) => {
      accumulator[key] = [...selectedFilters[key]].sort();
      return accumulator;
    }, {});
}
